var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
var $ = require('jquery');

import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
// import { Pager } from 'react-bootstrap';
import notification from '../Modal/notification';

// import StudentsTable from './StudentsTable';
var StudentRes = require('../../resources/student');

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;
var LinkStudent = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    // this.setState({
    //   sort: newSort,
    //   studentsData: [],
    //   isLoading: true,
    //   currentPager: 1,
    // }, () => {
    //   this.retrieveStudents();
    // });
  },
  getInitialState: function() {
    return {
        foundStudentMessage:'',
        _id: '',
        firstName: '',
        lastName: '',
        studentCode: '',
        email: '',
        // phone: '',
        // residentialAddress: '',
        // schoolName: '',
        // schoolClassName: '',
        // SA2Grade: '',
        // parentName: '',
        // parentNo: '',
        // parentEmail: '',
        // lastActivityDate: '',
        statusMode: [],
        currentMode: {},
        isLoading: true,
        displayButtonText:'Link'
      // conceptsMap: null,
    };
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  componentDidMount: function() {

    // var _this = this;
    // var statusMode = this.state.statusMode;
    // statusMode = STUDENT_STATUSES;
    // var currentUser = Auth.getCurrentUser();

    // var currentURL = window.location.href;
    // currentURL = currentURL.split("/");
    // var studentID = currentURL[currentURL.length-1]; //get the current class ID
    
    // // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // // if (currentUser.role === 'admin') {
    // //   statusMode = ADMIN_STATUSES;
    // // } else  {
    // //   statusMode = TEACHER_STATUSES;
    // // }
    // var currentMode = statusMode[0];
    // if (this.props.location.query.mode) {
    //   var mode = this.props.location.query.mode,
    //       mappedMode = statusMode.filter((value) => {
    //         return value.code === mode
    //       })[0];
    //   if (mappedMode) currentMode = mappedMode;
    // }
    // this.setState({
    //     _id: studentID,
    //     isLoading: true,
    //     statusMode: statusMode,
    //     currentMode: currentMode
    // }, function() {
    //   // var count = statusMode.length;
    //   // for (var i = 0; i < statusMode.length; i++) {
    //   //   this.countCollectionInMode(statusMode[i], function() {
    //   //     count--;
    //   //     if (count <= 0) _this.forceUpdate();
    //   //   });
    //   // }
    //   this.retrieveStudent();
    // });
  },
  getStudentWithCode: function(studentCode,callback) {
    callback = callback || function(){};
    var _this = this;

    var options = {};
        // options.skip = ITEM_LIMIT * (currentPager - 1);
        // options.limit = ITEM_LIMIT;
        // options.sort = this.state.sort || "dateCreated";
        options.conditions = {};
        // options.conditions.status = {
        //   "$in": this.state.currentMode.value
        // }
        // if (!this.state.currentMode.canApplyAdminRole) {
        //   options.conditions.creator = Auth.getCurrentUser()._id;
        // }
        // if (this.state.currentMode.include) {
        //   options.include = this.state.currentMode.include;
        //   options.includeConditions = includeConditions[options.include];
        // }
            // console.log("state of mdoe is " + this.state.currentMode.cols);
        
        // var currentURL = window.location.href;
        // currentURL = currentURL.split("/");

        // var studentID = this.state._id;//currentURL[currentURL.length-1]; //get the current class ID

        options.conditions.sort = this.state.sort || "firstName";
        // options.conditions.status = 'student';
        options.conditions.studentCode = studentCode;

        // var firstN = '';
        // var lastN = '';
        // if (fName) { firstN = fName; }
        // if (lName) { lastN = lName; }

        // options.conditions.sort = this.state.sort || "dateCreated";
        options.conditions.status = 'student';
        // options.conditions.firstName = firstN;
        // options.conditions.lastName = lastN;
        StudentRes.retrieveStudentWithCode(options, function(err, res) {
        // console.log("BEFORE DON sdfdsfsE!!");
        // if (callback) return callback(err, res);
        
            if (res.firstName==null) {

                this.setState({
                
                    foundStudentMessage:'No student with this link code was found'
                });

            } else {

                _this.setState({
                    _id:res._id,
                    foundStudentMessage: 'Found student: ' + res.firstName + " " + res.lastName,
                    studentName: res.firstName + " " + res.lastName
                }, () => {

                // console.log("DONE!!!");
                });
            }
        // console.log("RES IS :" + res.lastName);
            
        })
  },
  linkStudentWithCode: function(callback) {
    var _this = this;
    var studentCode = _this.state.studentCode;
    
    // var studentName = _this.state.studentName;//student.studentName;

    //TODO: get current teacher/admin's ID
    var currentUser = Auth.getCurrentUser();
    var createdByTeacher = currentUser._id; //current user (teacher/admin's id)
    // console.log("CURRENT USER ID IS " + createdByTeacher);

    var _id = _this.state._id;
    if (_this.state._id) { _id = _this.state._id; }

    var currentUser = Auth.getCurrentUser();
    var teacherID = currentUser._id;

    //generate a random string for the password
    console.log("studentName is " + _this.state.studentName);
        
    var ifError = false;

    if (!studentCode) { ifError = true; }

    if (ifError) {

        return notification.open({
            message: 'Cannot link Student',
            description: 'Student code is required'
        })
        
        // return;
    } 
    else {
        //alert("student code is " + studentCode);
        var student = {
            studentCode:studentCode,
            _id: _id,
            teacherID:teacherID
        };

        $("body, html").addClass("heavy-load");

        // if (_this.state._id) {

        this.setState({
            student: student
        }, () => {

            StudentRes.linkStudentWithCode(student, (err, res) => {
                $("body, html").removeClass("heavy-load");
                if (callback) return callback(err, res);
                if (err) {
                    return notification.open({
                    message: 'Error',
                    description: 'Cannot link student. Please try again'
                    })
                }
                this.setState({
                    student: res
                }, () => {
                    notification.open({
                    message: 'Success',
                    description: "Student has been linked!"
                    })
                    browserHistory.push('/students');
                    // if (_this.state.isCreateNew) browserHistory.push('/students');
                });

            });
        });

    } 
        
    
  },

  handleChangeData: function(field, e) {
    // console.log("STUDENT ID IS " + this.state._id);
      //alert("CHANGING INPUT " + field + " e is " + e.target.value);
    var update = {};
    var _this = this;
    this.getStudentWithCode(e.target.value);
    this.setState({
       
        foundStudentMessage:'',
        studentCode:e.target.value
    }, function(){

        

        // this.retrieveStudent(studentID);
    });
    // var student = _this.state.student;
    // student[field] = e.target.value;
    // update[field] = e.target.value;
    // this.setState(update, function (){

    //     this.setState({ student:student});
    // });
  },
  
  render: function() {
    var _this = this;
    return (
        <div className="students">
            
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo"><h3> Link student </h3></label>
                </div>
                
            </div>
            <hr/>
            <div className="row createStudentRow">
                <div className="col col-md-2 DivlblCreateStudent">
                    <label className="lblCreateStudent"></label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <label className="lblStudentInfo"><h5>{_this.state.foundStudentMessage}</h5></label>
                </div>
            </div>
            <br/>
            <div className="row">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent">Student code:</label>
                </div>
                <div className="col col-md-10 DivTxtCreateStudent">
                    <input type="text" placeholder="Enter student code to link with" className="form-control mark-input createStudentField" onChange={_this.handleChangeData.bind(_this, 'studentCode')} value={_this.state.studentCode} />
                </div>
            </div>
            <br/>
            
            <br/><br/>
            <div className="content-toolbar">
                <div className="col col-md-2 DivlblCreateStudent">
                <label className="lblCreateStudent"></label>
                </div>
                <div className="createButton">
                    
                    <RaisedButton
                        target="_blank"
                        label={_this.state.displayButtonText}
                        primary={true}
                        onClick={this.linkStudentWithCode.bind(_this, null)}
                    />
                    {/*<RaisedButton
                    onClick={this.saveStudent.bind(_this, null)}
                    target="_blank"
                    label="Create Student"
                    primary={true}
                    icon={<i style={{"color": "white"}} className="fa fa-save" />}
                    />*/}
                </div>
            </div>
        </div>
    );
  }

});

module.exports = LinkStudent;



/** WEBPACK FOOTER **
 ** ./src/components/Students/LinkStudent.js
 **/